import { render, staticRenderFns } from "./insuplist.vue?vue&type=template&id=1b89034b&scoped=true&"
import script from "./insuplist.vue?vue&type=script&lang=js&"
export * from "./insuplist.vue?vue&type=script&lang=js&"
import style0 from "./insuplist.vue?vue&type=style&index=0&id=1b89034b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b89034b",
  null
  
)

export default component.exports